export default __webpack_public_path__ + "static/media/2269_open.610ce0b2.jpg";